export const readFile = (blob: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: any) => resolve(event.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
});

export function convertClipboardItemsToFiles(itemList: DataTransferItemList): File[] {
    let files: File[] = [];
    for (let index = 0; index < itemList.length; index++) {
        const file: File | null = itemList[index].getAsFile();
        if (file) files.push(file);
    };
    return [...files];
}

export function getBrowserName(): string {
    const userAgent: string = navigator.userAgent;

    if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
        return "Google Chrome";
    } else if (userAgent.indexOf("Firefox") > -1) {
        return "Mozilla Firefox";
    } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
        return "Safari";
    } else if (userAgent.indexOf("Edg") > -1) {
        return "Microsoft Edge";
    } else if (userAgent.indexOf("MSIE") > -1 || !!document.documentMode === true) {
        return "Internet Explorer";
    } else {
        return "Unknown Browser";
    }
}